// Types pour Flowbox
export interface FlowboxProduct {
  id: string;
  quantity: number;
  price: number;
  currency: string;
}

interface FlowboxCustomerData {
  name: string;
  lastName: string;
  email: string;
  mobile: string;
}

interface FlowboxCheckoutConfig {
  apiKey: string;
  products: FlowboxProduct[];
  orderId: number;
  locale?: string;
  customerData?: FlowboxCustomerData;
  enableWebAnalytics?: boolean;
}

interface FlowboxWindow extends Window {
  flowboxCheckout?: {
    checkout: (config: FlowboxCheckoutConfig) => void;
  };
}

declare const window: FlowboxWindow;

export default class TrackingFlowbox {
  private apiKey: string;

  private scriptLoaded = false;

  constructor(apiKey: string) {
    this.apiKey = apiKey;
  }

  private loadFlowboxScript(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (this.scriptLoaded && window.flowboxCheckout) {
        resolve();
        return;
      }

      const script = document.createElement('script') as any;
      script.type = 'text/javascript';

      const onScriptLoad = () => {
        this.scriptLoaded = true;
        resolve();
      };

      if ('readyState' in script) {
        // Pour les anciens navigateurs IE
        script.onreadystatechange = () => {
          if (
            script.readyState === 'loaded' ||
            script.readyState === 'complete'
          ) {
            script.onreadystatechange = null;
            onScriptLoad();
          }
        };
      } else {
        script.onload = onScriptLoad;
      }

      script.onerror = () => {
        reject(new Error('Erreur lors du chargement du script Flowbox'));
      };

      script.src = '//connect.getflowbox.com/bzfy-checkout.js';
      document.getElementsByTagName('head')[0].appendChild(script);
    });
  }

  async trackCheckout(
    config: Omit<FlowboxCheckoutConfig, 'apiKey'>
  ): Promise<void> {
    try {
      await this.loadFlowboxScript();

      if (!window.flowboxCheckout) {
        throw new Error("Flowbox checkout n'est pas disponible");
      }

      const checkoutConfig: FlowboxCheckoutConfig = {
        apiKey: this.apiKey,
        ...config,
      };

      window.flowboxCheckout.checkout(checkoutConfig);
    } catch (error) {
      console.error('Erreur lors du tracking Flowbox:', error);
      throw error;
    }
  }
}
